import {
    Box,
    Button,
    Grid,
    Link,
    Typography,
} from '@mui/material'
import useScreenFlow from '../../hooks/useScreenFlow'
import {useContext} from "react";
import {OrgCustomizationContext} from "../../themes/OrgCustomizationProvider";
import useRedirect from "../../hooks/useRedirect";

const AuthSelection: React.FC = () => {
    const {navigateTo} = useScreenFlow()
    const {t, theme} = useContext(OrgCustomizationContext)
    const style = {color: theme.palette.primary.main}
    const {loginUrl, registerUrl} = useRedirect()

    const head = t('gi_existing_customer')
    const content = t('gi_login_for_prefill')//'Login and we will pre-fill the customer information section of the form.'

    return (
        <Box alignItems='center'>
            <Grid container spacing={2} rowSpacing={2} marginBottom='1rem'>
                <Grid item>
                    <Typography
                        variant='h5'
                        color={style.color}
                    >
                        {head}
                    </Typography>
                    <Box height='1rem'/>
                    <Typography variant='subtitle2'>{content}</Typography>
                </Grid>

            </Grid>
            {/* <Box height='1rem'/> */}
            <Grid container spacing={2}>


                <Grid item>
                    <Button
                        variant='contained'
                        fullWidth
                        href={loginUrl}
                    >
                        <Typography variant='button'>{t('gi_login')}</Typography>
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        variant='contained'
                        onClick={() => navigateTo('/guestform')}
                        color='secondary'
                        fullWidth
                    >
                        <Typography variant='button'>{t('gi_proceed_as_guest')}</Typography>
                    </Button>
                </Grid>

            </Grid>

            <Box height='1rem'/>

            <Link
                sx={{
                    color: 'black',
                    ":hover": {
                        cursor: 'pointer',
                    },
                }}
                href={registerUrl}
            >
                {t('gi_new_user')}
            </Link>

        </Box>
    )
}

export default AuthSelection;
